import { useContext } from "react";
import type { AuthProviderState } from "~/models/AuthProviderState";
import { AuthenticationContext } from "~/services/AuthenticationProvider";

export function useAuthenticationContext(): AuthProviderState {
    const authentication = useContext(AuthenticationContext);
    return authentication;
}
